import { Empty } from '../Common/Empty'
import type { DraftPreview, PinterestPostType, ProfilePreview } from '../types'
import { PinterestPost } from './components/Post'
import { PostPreviewCard } from '../Common/styles'

import type { JSX } from 'react'

export const PinterestPreview = ({
  draft,
  profile,
}: {
  draft: DraftPreview
  profile: ProfilePreview
}): JSX.Element => {
  const draftPinterest: PinterestPostType = {
    content: {
      ...draft,
      text: draft.text,
    },
  }

  if (draft.isEmpty) return <Empty />

  return (
    <PostPreviewCard data-testid="pinterest-preview">
      <PinterestPost content={draftPinterest.content} profile={profile} />
    </PostPreviewCard>
  )
}
